import Cookies from "js-cookie";
export const RedirectToRoute = (err) => {
  if (err?.response?.status === 401) {
    Cookies.remove("ntr-token");
    window.location.reload();
  }
};
